export default __webpack_public_path__ + "static/media/bronze-medal.4a349c3c.svg";